import { render, staticRenderFns } from "./ProductCatalog.vue?vue&type=template&id=77e3d1de&scoped=true&"
import script from "./ProductCatalog.vue?vue&type=script&lang=ts&"
export * from "./ProductCatalog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCatalog.vue?vue&type=style&index=0&id=77e3d1de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e3d1de",
  null
  
)

export default component.exports